var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pie__wrapper"},[(_setup.loading)?_c('div',{staticClass:"pie__loader"},[_c('q-spinner',{attrs:{"color":"primary","size":"3em"}})],1):_c(_setup.pieChart,{attrs:{"chartData":_setup.chartData,"wrapLegend":_setup.pieWrap}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }